import React, { useContext } from 'react';
import { hasModule, trimmer } from '../helpers';
import { JobContext } from '../JobContext';
export var JobDescription = function JobDescription() {
  var _useContext = useContext(JobContext),
      forceSmall = _useContext.forceSmall,
      shortDescription = _useContext.shortDescription,
      cardStyle = _useContext.cardStyle,
      modulesV2 = _useContext.modulesV2,
      forceJobShortDescription = _useContext.forceJobShortDescription;

  var hasDescription = hasModule('Job Short Description', modulesV2) || forceJobShortDescription || cardStyle in {
    'sponsored-job': true,
    'job-of-the-week': true,
    gold: true,
    silver: true
  };
  if (!hasDescription || !shortDescription) return null;
  return /*#__PURE__*/React.createElement("p", null, trimmer(shortDescription, 85, forceSmall));
};
JobDescription.displayName = "JobDescription";